import { createEvent, createStore } from "effector";

export const setProgress = createEvent<number>();

export const $progress = createStore(0).on(setProgress, (_, payload) => payload);

export const $loadingStatus = $progress.map((state) => (state < 100 ? "loading" : "ready"));
